import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    height: "100vh",
    left: 0,
    position: "relative",
    overflowY: "auto",
    // background: theme.palette.custom.light,
    background: "#ffffff",
    boxShadow: "8px 0px 16px rgb(0 0 0 / 8%)",
    scrollbarWidth: "thin",
    "& .MuiSvgIcon-root": {
      color: "#022247",
    },
  },
 sidebarmenu: {
   width: "100%",
   flexDirection: "column",
   display: "flex",
   scrollbarWidth: "none"
  },
  sidebarmenu2:{
    height: "100vh",
    flexDirection: "column",
    display: "flex",
    overflowX:"hidden",
    scrollbarWidth: "none"
  },
  headstamps:{
    alignItems: "center",
    position: "sticky",
    background : "#fff",
    zIndex: 9,
    top:0,
    margin: "0px 0px",
    padding: "10px 0px",
    transition: "margin 1.0s ease-in-out, padding 1.0s ease-in-out",
  },
  headstamps2:{
    alignItems: "center",
    position: "sticky",
    background : "#fff",
    zIndex: 9,
    top:0,
    margin: "0px 0px",
    padding: "10px 0px",
    transition: "margin 1.0s ease-in-out, padding 1.0s ease-in-out",
  },
  headstampitems: {
    display: "flex",
    justifyContent: "center",
  },
  subitemsicon:{
    justifyContent: "center",
  },
  subitemscontent:{
    margin: "10px 5px"
  },
  logo: {
    width: 60,
    height: 60,
    objectFit: "cover",
    cursor: "pointer",
  },
  menuLabels: {
    "& .MuiTypography-root": {
      color: "#000",
      fontWeight: 700,
    },
  },
  menuLabels2: {
    "& .MuiTypography-root": {
      fontWeight: 500,
      color: "#000",
    },
  },
  subMenuLabel: {
    "& .MuiTypography-root": {
      color: "#000000",
      paddingInlineStart: 18,
    },
  },
  subitemscolor:{
    "& .makeStyles-subMenuLabel-40":{
    background: "#EAEDEF",
    }
  }
}));

export default useStyles;
